import { useState, useEffect } from "react";

// Custom Hook to get window size category (SM, MD, LG)
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState(getSizeCategory());

  // Function to determine size category
  function getSizeCategory() {
    if (globalThis.window) {
      const width = window.innerWidth;

      if (width < 640) return "SM";
      if (width >= 640 && width < 1024) return "MD";
      return "LG";
    } else {
      return "LG"
    }
  }

  // Event listener for window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSizeCategory());
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
